/**
 * Política de senha (espelha backend/services/security.py).
 * Mínimo 12 chars + minúscula + maiúscula + dígito + especial.
 * Bloqueia repetições 4+ do mesmo caractere e senhas notoriamente fracas.
 */
export const MIN_PASSWORD_LENGTH = 12;

const COMMON = new Set([
  '123456789012',
  'qwertyuiop12',
  'password1234',
  'admin1234567',
]);

export function validatePassword(password) {
  if (!password || password.length < MIN_PASSWORD_LENGTH) {
    return { ok: false, error: `A senha deve ter ao menos ${MIN_PASSWORD_LENGTH} caracteres.` };
  }
  if (!/[a-z]/.test(password)) return { ok: false, error: 'A senha deve conter ao menos 1 letra minúscula.' };
  if (!/[A-Z]/.test(password)) return { ok: false, error: 'A senha deve conter ao menos 1 letra maiúscula.' };
  if (!/\d/.test(password)) return { ok: false, error: 'A senha deve conter ao menos 1 dígito.' };
  if (!/[^A-Za-z0-9]/.test(password)) return { ok: false, error: 'A senha deve conter ao menos 1 caractere especial (ex: !@#$%).' };
  if (/(.)\1{3,}/.test(password)) return { ok: false, error: 'A senha não pode repetir o mesmo caractere 4+ vezes.' };
  if (COMMON.has(password.toLowerCase())) return { ok: false, error: 'Esta senha é muito comum.' };
  return { ok: true };
}

export function getPasswordStrength(password) {
  let score = 0;
  if ((password || '').length >= MIN_PASSWORD_LENGTH) score++;
  if ((password || '').length >= 16) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[a-z]/.test(password)) score++;
  if (/\d/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;

  if (score <= 2) return { level: 'Fraca', color: 'bg-red-500', width: '25%', textColor: 'text-red-600' };
  if (score <= 3) return { level: 'Razoável', color: 'bg-orange-500', width: '45%', textColor: 'text-orange-600' };
  if (score <= 4) return { level: 'Média', color: 'bg-yellow-500', width: '65%', textColor: 'text-yellow-600' };
  if (score <= 5) return { level: 'Forte', color: 'bg-green-500', width: '85%', textColor: 'text-green-600' };
  return { level: 'Muito Forte', color: 'bg-emerald-500', width: '100%', textColor: 'text-emerald-600' };
}
